import React, { Component } from "react";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { connect } from 'react-redux';
const dropdownItem=["Item 1","Item 2", "Item 3"]
const listItem = [
    {
        listTitle: "Circuit",
        href:"/Internal/Inventory/Circuit"
    }        
    ,{
        listTitle: "Equipment"
        , href:"/Internal/Inventory/Equipment"
    }
    ,{
        listTitle: "ASPU"
        , href:"/Internal/Inventory/ASPU"
    } ,{
        listTitle: "ASR"
        , href:"/Internal/Inventory/ASR"
    }
];
class InventoryAspu extends Component {
    render(){
      
        return(
            <HeaderFilter enableDropdown={false} dropdownItem={dropdownItem} enableExtractBtn={true} enableFilterBtn={false} enableExportExcel={false} btnAddTitle="Add Plan" 
            enableAddBtn={false} enableUploadBtn={false} listItem={listItem} haveTab={true}/>          
        )
    }
}

export default connect()(InventoryAspu);